/**
 * BESC Draw demo switch.
 *
 * Demo is the default: packs open off-chain from a local random seed, and every
 * value-out path (sell-back, shipping, GEM / referral cash-out, daily bonus,
 * battles) is blocked. Set VITE_CARD_PACKS_DEMO=false at launch.
 *
 * Packs drawn in demo are tagged `demo: true` and stay non-redeemable after launch.
 */
export const DEMO_MODE = import.meta.env.VITE_CARD_PACKS_DEMO !== "false";

export const DEMO_BLOCKED_MSG =
  "BESC Draw is in demo mode — selling, shipping and cash-outs open at launch. " +
  "Bought packs before the demo? Contact support for a refund.";

export function randomSeed(): bigint {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  return BigInt("0x" + Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join(""));
}
